import { render, staticRenderFns } from "./StrategyIcon.vue?vue&type=template&id=82fcc030&scoped=true&"
import script from "./StrategyIcon.vue?vue&type=script&lang=js&"
export * from "./StrategyIcon.vue?vue&type=script&lang=js&"
import style0 from "./StrategyIcon.vue?vue&type=style&index=0&id=82fcc030&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "82fcc030",
  null
  
)

export default component.exports